export default "__VITE_ASSET__J3v87MxE__"